var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal-duplicate",
    {
      attrs: {
        "max-width": "35%",
        icon: "icon-newticket",
        "icon-type": "icon",
        "hide-close-button": true,
        loading: _vm.loading,
        title: _vm.$t(_vm.lblSetting.ticketCreateGroupTitle)
      },
      on: { onRecord: _vm.handleSave },
      model: {
        value: _vm.coModalVisible,
        callback: function($$v) {
          _vm.coModalVisible = $$v
        },
        expression: "coModalVisible"
      }
    },
    [
      _c(
        "v-layout",
        { attrs: { column: "", wrap: "", "mr-2": "", "mt-2": "" } },
        [
          _c(
            "base-control-label",
            {
              attrs: {
                required: "",
                xs4: "",
                label: _vm.lblSetting.ticketGroup
              }
            },
            [
              _c("v-text-field", {
                attrs: {
                  rules: _vm.dtRules.nameRules,
                  counter: "25",
                  maxlength: "25",
                  solo: ""
                },
                model: {
                  value: _vm.name,
                  callback: function($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "base-control-label",
            {
              attrs: {
                required: "",
                xs4: "",
                label: _vm.lblSetting.ticketGroupMember
              }
            },
            [
              _c("base-entities-search", {
                attrs: { rules: _vm.dtRules.independentContractor },
                model: {
                  value: _vm.participants,
                  callback: function($$v) {
                    _vm.participants = $$v
                  },
                  expression: "participants"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-364fdb0a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-364fdb0a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-sidebar-modal/template.html
// module id = null
// module chunks = 